export const PHONE = "07301799929";
export const PHONE_INTL = "+447301799929"; // UK international (drop leading 0)
export const EMAIL = "tyrespro26@gmail.com";
export const WHATSAPP_DEFAULT_MSG = "Hi TyresPro, I need emergency tyre assistance.";

export const telHref = `tel:${PHONE_INTL}`;
export const waHref = (msg = WHATSAPP_DEFAULT_MSG) =>
  `https://wa.me/${PHONE_INTL.replace("+", "")}?text=${encodeURIComponent(msg)}`;
export const mailHref = `mailto:${EMAIL}`;

/* === MAINTENANCE / HOLIDAY MODE ============================================
   Flip this to `false` when you are back from holiday to re-open the site.
   While `true`:
     - Visitors see the homepage blurred in the background with a yellow
       "Back Soon" message in Bebas Neue over it.
     - All clicks, scrolling and forms are blocked.
   Owner bypass (so you can still preview the live site while it's paused):
     - Add ?preview=1 to the URL ONCE, e.g. https://tyrespro.co.uk/?preview=1
     - It's remembered in your browser until you clear site data.
   ========================================================================= */
export const MAINTENANCE_MODE = false;

export const VAN_IMAGE =
  "https://customer-assets.emergentagent.com/job_mobile-tyre-service-1/artifacts/x72kovam_WhatsApp%20Image%202026-06-08%20at%2008.23.54.jpeg";

export const LOGO_IMAGE = "/tyrespro-logo.png?v=3";

export const HERO_BG =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_mobile-tyre-service-1/artifacts/59ifr8fk_ChatGPT%20Image%20Jul%2017%2C%202026%2C%2009_37_28%20PM.png";
// TyresPro Ltd branded Mercedes Sprinter — owner-supplied van photo (v2)

export const SERVICE_IMAGES = {
  emergency: "https://images.pexels.com/photos/3806249/pexels-photo-3806249.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  puncture: "https://images.unsplash.com/photo-1613214149922-f1809c99b414?auto=format&fit=crop&w=1200&q=80",
  replacement: "https://images.pexels.com/photos/16685596/pexels-photo-16685596.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  runflat: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?auto=format&fit=crop&w=1200&q=80",
  balancing: "https://images.unsplash.com/photo-1601362840469-51e4d8d58785?auto=format&fit=crop&w=1200&q=80",
  locking: "https://images.unsplash.com/photo-1486496572940-2bb2341fdbdf?auto=format&fit=crop&w=1200&q=80",
};
